(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.KBLashMatchQuiz = api;
    const start = () => {
      const host = root.document.getElementById('kb-lash-match-quiz');
      if (host) api.mount(root, host);
    };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const DAY = 86400000;
  const MATCHES = Object.freeze({ Babyface: 'natural', Caris: 'soft', Dana: 'full', Legacy: 'full' });

  function resolveMatch(vibe, occasion) {
    if (vibe === 'natural') return 'Babyface';
    if (vibe === 'soft') return 'Caris';
    if (vibe === 'full' && occasion === 'stage') return 'Dana';
    if (vibe === 'full' && occasion === 'events') return 'Legacy';
    throw new Error('Incomplete quiz path');
  }

  function excludedPath(path) {
    const p = String(path || '/').replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
    return /^\/(?:cart|checkouts?)(?:\/|$)/i.test(p) || /^\/pages\/register(?:\/|$)/i.test(p);
  }

  function cooldown(record, now) {
    const time = Number(record && record.closedAt);
    return Number.isFinite(time) && time > 0 && time <= now && now - time < 7 * DAY;
  }

  function scrollFraction(height, viewport, offset) {
    const range = height - viewport;
    return range > 0 ? Math.max(0, Math.min(1, offset / range)) : 0;
  }

  function nativeMatch(detail, forms, company) {
    if (!detail || detail.companyId !== company) return null;
    return Object.keys(MATCHES).find(name => forms[name] === detail.formId) || null;
  }

  function enabled(config, path) {
    return config.enabled === true && config.couponBindingReady === true && config.shopifySubscriber !== true && !excludedPath(path);
  }

  function mount(win, host) {
    if (host.dataset.mounted === 'true') return null;
    let config;
    try { config = JSON.parse(host.querySelector('[data-quiz-config]').textContent); } catch (_) { return null; }
    if (!enabled(config, win.location.pathname)) return null;
    if (!Object.keys(MATCHES).every(name => /^[A-Za-z0-9]{6}$/.test(config.forms[name] || ''))) return null;
    host.dataset.mounted = 'true';
    const doc = win.document;
    const dialog = host.querySelector('[data-quiz-dialog]');
    const panel = host.querySelector('[data-quiz-panel]');
    const depot = host.querySelector('[data-quiz-depot]');
    const nativeHost = host.querySelector('[data-quiz-native-host]');
    const teaser = host.querySelector('[data-quiz-teaser]');
    const back = host.querySelector('[data-quiz-back]');
    const picture = host.querySelector('[data-quiz-picture]');
    const desktopPhoto = picture.querySelector('img');
    const mobilePhoto = picture.querySelector('source');
    const nativeNodes = Object.fromEntries(Object.keys(MATCHES).map(name => [name, depot.querySelector('[data-native-match="' + name + '"]')]));
    if (Object.values(nativeNodes).some(node => !node)) return null;
    const ready = new Set();
    const key = 'kb_lash_match_v1';
    let record = {};
    try { record = JSON.parse(win.localStorage.getItem(key) || '{}') || {}; } catch (_) {}
    let screen = 'hook', match = null, vibe = null, isOpen = false, requested = false, completed = false, restoringFocus = null;
    let frame = null, nativeFocusTimer = null;
    const i18n = Object.fromEntries(Object.entries(config.copy).map(([key, value]) => [key, String(value).replace(/&#39;/g, "'")]));
    const escape = text => String(text).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
    const allReady = () => ready.size === Object.keys(MATCHES).length;
    const putRecord = () => { try { win.localStorage.setItem(key, JSON.stringify(record)); } catch (_) {} };
    const getTitle = () => host.querySelector('[data-step-title]');
    const button = (label, action, choice) => '<button type="button" class="kbq-choice" ' + (choice ? 'data-match="' + choice + '"' : 'data-action="' + action + '"') + '>' + escape(label) + '</button>';
    const progress = count => '<div class="kbq-progress" aria-hidden="true">' + [0, 1, 2, 3].map(n => '<span class="' + (n < count ? 'done' : '') + '"></span>').join('') + '</div>';
    const logotype = '<img class="kbq-logo" src="' + escape(config.assets.logo) + '" width="146" height="18" alt="Kemp Beauty">';

    function releaseNative() {
      for (const node of Object.values(nativeNodes)) {
        node.hidden = true;
        node.inert = true;
        depot.appendChild(node);
      }
      nativeHost.hidden = true;
    }

    function setPhoto(result) {
      const source = result ? config.assets[match] : config.assets.desktop;
      desktopPhoto.src = source;
      desktopPhoto.alt = result ? i18n.model_alt : i18n.products_alt;
      mobilePhoto.srcset = result ? source : config.assets.mobile;
      dialog.classList.toggle('kbq-result', result);
    }

    function render() {
      win.clearTimeout(nativeFocusTimer);
      setPhoto(screen === 'result');
      back.hidden = screen === 'hook' || screen === 'result';
      panel.hidden = screen === 'email' || screen === 'result';
      if (screen === 'email' || screen === 'result') {
        panel.replaceChildren();
        nativeHost.hidden = false;
        const node = nativeNodes[match];
        nativeHost.appendChild(node);
        node.hidden = false;
        node.inert = false;
        nativeFocusTimer = win.setTimeout(() => {
          if (isOpen && screen === 'email') node.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        }, 0);
        return;
      }
      releaseNative();
      let body;
      if (screen === 'hook') body = '<h2 data-step-title tabindex="-1">' + escape(i18n.hook_title) + '</h2><p class="kbq-sub">' + escape(i18n.hook_copy) + '</p><button type="button" class="kbq-primary" data-action="begin">' + escape(i18n.begin) + '</button><button type="button" class="kbq-decline" data-action="close">' + escape(i18n.decline) + '</button>';
      if (screen === 'vibe') body = progress(1) + '<h2 class="kbq-question" data-step-title tabindex="-1">' + escape(i18n.vibe_title) + '</h2><div class="kbq-choices">' + button(i18n.natural, null, 'Babyface') + button(i18n.soft, null, 'Caris') + button(i18n.full, 'glam') + '</div>';
      if (screen === 'occasion') body = progress(2) + '<h2 class="kbq-question" data-step-title tabindex="-1">' + escape(i18n.occasion_title) + '</h2><div class="kbq-choices">' + button(i18n.stage, null, 'Dana') + button(i18n.events, null, 'Legacy') + '</div>';
      panel.innerHTML = logotype + body;
      if (isOpen) getTitle()?.focus({ preventScroll: true });
    }

    function open(manual) {
      if (isOpen || completed || !allReady() || !enabled(config, win.location.pathname)) return false;
      if (!manual && cooldown(record, Date.now())) return false;
      if (Array.from(doc.querySelectorAll('dialog[open]')).some(node => node !== dialog)) return false;
      restoringFocus = doc.activeElement;
      isOpen = true;
      teaser.hidden = true;
      teaser.setAttribute('aria-expanded', 'true');
      render();
      dialog.showModal();
      getTitle()?.focus({ preventScroll: true });
      return true;
    }

    function requestOpen() {
      requested = true;
      open(false);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      record.closedAt = Date.now();
      putRecord();
      dialog.close();
      teaser.hidden = completed || !allReady();
      teaser.setAttribute('aria-expanded', 'false');
      if (!teaser.hidden) teaser.focus({ preventScroll: true });
      else restoringFocus?.focus?.({ preventScroll: true });
    }

    function choose(value) {
      if (completed || !Object.hasOwn(MATCHES, value) || !ready.has(value)) return;
      const nextVibe = MATCHES[value];
      if (screen === 'vibe' && nextVibe === 'full') return;
      if (screen === 'occasion' && nextVibe !== 'full') return;
      match = value;
      vibe = nextVibe;
      screen = 'email';
      render();
    }

    function onNative(detail) {
      const name = nativeMatch(detail, config.forms, config.companyId);
      if (!name) return;
      if (detail.type === 'embedOpen') {
        ready.add(name);
        if (allReady()) {
          if (cooldown(record, Date.now()) && !completed) teaser.hidden = false;
          if (requested) open(false);
        }
      }
      if (detail.type === 'submit' && isOpen && screen === 'email' && match === name) {
        completed = true;
        record.closedAt = Date.now();
        putRecord();
        screen = 'result';
        render();
      }
    }

    dialog.addEventListener('click', event => {
      const target = event.target.closest('button');
      if (!target || !dialog.contains(target)) return;
      if (target.dataset.match) choose(target.dataset.match);
      const action = target.dataset.action;
      if (action === 'begin' && screen === 'hook') { screen = 'vibe'; render(); }
      if (action === 'glam' && screen === 'vibe') { vibe = 'full'; screen = 'occasion'; render(); }
      if (action === 'close') close();
      if (action === 'back' && !completed) {
        screen = screen === 'email' ? (vibe === 'full' ? 'occasion' : 'vibe') : screen === 'occasion' ? 'vibe' : 'hook';
        render();
      }
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    teaser.addEventListener('click', () => open(true));
    win.addEventListener('klaviyoForms', event => onNative(event.detail));
    for (const event of win.KBLashQuizNativeQueue || []) onNative(event);
    win.KBLashQuizNativeQueue = null;
    const syncNativeReadiness = () => {
      for (const [name, node] of Object.entries(nativeNodes)) {
        if (node.querySelector('form input[type="email"]')) ready.add(name);
      }
      if (allReady()) {
        readinessObserver?.disconnect();
        if (cooldown(record, Date.now()) && !completed) teaser.hidden = false;
        if (requested) open(false);
      }
    };
    const readinessObserver = win.MutationObserver ? new win.MutationObserver(syncNativeReadiness) : null;
    readinessObserver?.observe(depot, { childList: true, subtree: true });
    syncNativeReadiness();
    win.setTimeout(requestOpen, 8000);
    const checkScroll = () => {
      frame = null;
      if (scrollFraction(doc.documentElement.scrollHeight, win.innerHeight, win.scrollY) >= 0.4) requestOpen();
    };
    win.addEventListener('scroll', () => { if (!frame) frame = win.requestAnimationFrame(checkScroll); }, { passive: true });
    checkScroll();
    doc.addEventListener('mouseout', event => {
      if (!event.relatedTarget && event.clientY <= 0 && win.matchMedia('(min-width: 651px) and (pointer: fine)').matches) requestOpen();
    });
    return Object.freeze({ getState: () => ({ screen, match, vibe, isOpen, completed, ready: ready.size }), open, close });
  }

  return Object.freeze({ MATCHES, resolveMatch, excludedPath, cooldown, scrollFraction, nativeMatch, enabled, mount });
});
